<h1 *ngIf="idstr=='publicExampleID'">Examples</h1>
<hr *ngIf="idstr=='publicExampleID'">

<!-- Main container with two columns -->
<div class="examples-container">

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-spinner-overlay">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <!-- Left Column: Categories and Projects List -->
    <div class="main-content-area">
        <div class="nav-bar">
            <div (click)="upPath(oldpath)" style="cursor:pointer;" class="folder-up-button">
                <div *ngIf="oldpath" class="projectfolder-button-content">
                    <i style="font-size:20px;" class="fa far fas far fa-arrow-alt-circle-up"></i>
                    Folder Up
                </div>
            </div>
            <div class="current-folder-display">Current: <span *ngIf="!curnode">root</span> {{curnode?.name}}</div>
        </div>

        <div class="entries-grid" *ngIf="entries && entries.length > 0">
            <div *ngFor="let e of entries; let i = index" class="grid-item folder-item"
                (click)="this.changePath(e.name,i,e)">
                <img src="/assets/folder.png" alt="Folder icon">
                <div class="item-name"> {{e.name}}</div>
            </div>
        </div>
        <div *ngIf="entries && entries.length === 0 && curnode">
            <!-- This category is empty or a leaf node without further subcategories -->
        </div>

        <h4 *ngIf="curnode" [hidden]="isLoading">Projects in {{curnode?.name}}</h4>
        <div class="projects-grid" *ngIf="curprojects && curprojects.length > 0" [hidden]="isLoading">
            <div *ngFor="let p of curprojects" class="grid-item project-item" (click)="selectProjectForPreview(p)"
                [class.selected]="p === selectedProjectForPreview">
                <img [src]="p.image" alt="Project image" class="project-image" />
                <div class="item-name project-name"> {{p.name}}</div>
            </div>
        </div>
        <div *ngIf="curprojects && curprojects.length === 0 && curnode && (!entries || entries.length === 0)"
            [hidden]="isLoading">
            No example projects found in this category.
        </div>
        <div *ngIf="!curnode && (!curprojects || curprojects.length === 0)" [hidden]="isLoading">
            Select a category to browse example projects.
        </div>
    </div>

    <!-- Right Column: Project Preview -->
    <div class="preview-area" [hidden]="isLoading">
        <div *ngIf="selectedProjectForPreview" class="preview-content">
            <h3 style="font-size:20px;font-weight:bold;">{{ selectedProjectForPreview.name }}</h3>
            <div class="image-container">
                <img [src]="selectedProjectForPreview.image" alt="Preview of {{ selectedProjectForPreview.name }}"
                    class="preview-image">
            </div>
            <!-- Placeholder for more details -->
            <!-- <p>{{ selectedProjectForPreview.description }}</p> -->
            <div class="project-description" style="overflow-y: auto;max-height:300px;">
                <p class="description-text" [innerHTML]="selectedProjectForPreview.description"></p>
            </div>

            <button mat-raised-button color="primary" (click)="confirmSelection()" class="use-example-button">
                Use this Example
            </button>
        </div>
        <div *ngIf="!selectedProjectForPreview" class="no-preview-placeholder">
            <p>Select a project from the list to see its preview.</p>
        </div>
    </div>
</div>

<style>
    .description-text ul {
        list-style-type: disc !important;
        margin-left: 20px;
    }

    .project-description ol {
        list-style-type: decimal !important;
        margin-left: 20px !important;
    }


    .examples-container {
        display: flex;
        flex-wrap: wrap;
        /* Allow wrapping for smaller screens if needed */
        gap: 20px;
        padding: 15px;
        min-height: 500px;
        /* Ensure container has some height */
        position: relative;
        /* For loading spinner positioning */
        flex-grow: 1;
        /* Allow container to grow to fill host height */
        overflow: hidden;
        /* Prevent this container from scrolling, manage scroll on children */
    }

    .loading-spinner-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        /* Ensure it's on top */
    }

    .main-content-area {
        flex: 2;
        /* Takes 2/3 of the space */
        min-width: 300px;
        /* Minimum width before wrapping or shrinking too much */
        display: flex;
        flex-direction: column;
        gap: 15px;
        overflow-y: auto;
        /* Allow scrolling for categories/projects list */
    }

    .preview-area {
        flex: 1;
        /* Takes 1/3 of the space */
        min-width: 250px;
        /* Minimum width */
        padding-left: 15px;
        border-left: 1px solid #e0e0e0;
        display: flex;
        /* For centering placeholder */
        flex-direction: column;
        justify-content: space-between;
        /* Pushes button to bottom */
        overflow: hidden;
        /* Manage scroll on children like description */
    }

    .preview-content {
        /* Styles for the content when a project is selected */
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        /* Allows content to take available space */
        overflow: hidden;
        /* Ensure this doesn't scroll, description will */
    }

    .image-container {
        flex-grow: 1;
        /* Allows image container to grow and push button down */
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* Center image if it's smaller than max-height */
        overflow: hidden;
        /* Prevents image from overflowing */
        margin-bottom: 15px;
    }

    .preview-image {
        max-width: 100%;
        /* height: auto; Removed to allow max-height to control */
        max-height: 300px;
        /* Added max-height */
        object-fit: contain;
        /* Changed from cover to contain to see whole image */
        border: 1px solid #ddd;
        /* margin-bottom: 15px; Moved to image-container */
        border-radius: 4px;
        align-self: center;
        /* Center image within the container */
    }

    .use-example-button {
        width: 100%;
        margin-top: 10px;
        /* flex-grow: 1; Removed */
        display: flex;
        align-items: center;
        justify-content: center;
        /* height: 100%; Removed */
    }

    .no-preview-placeholder {
        text-align: center;
        color: #757575;
        margin-top: 30px;
        flex-grow: 1;
        /* Allows vertical centering if preview-area is flex column */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nav-bar {
        display: flex;
        align-items: center;
        gap: 15px;
        /* margin-bottom: 10px; Removed as main-content-area has gap */
    }

    .folder-up-button {
        cursor: pointer;
    }

    .projectfolder-button-content {
        /* Renamed from projectfolder to avoid conflict */
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        border-radius: 4px;
        background-color: #f0f0f0;
        border: 1px solid #ddd;
    }

    .projectfolder-button-content:hover {
        background-color: #e0e0e0;
    }


    .current-folder-display {
        font-size: 1em;
        font-weight: 500;
        color: #333;
    }

    .entries-grid,
    .projects-grid {
        display: grid;
        gap: 15px;
        /* Reduced gap */
    }

    .entries-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        /* Smaller items for categories */
    }

    .projects-grid {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        /* Slightly smaller project items */
    }

    .grid-item {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 10px;
        /* Reduced padding */
        cursor: pointer;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        /* Better alignment for content */
        transition: box-shadow 0.2s ease, border-color 0.2s ease;
        background-color: #fff;
    }

    .grid-item:hover {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        border-color: #bbb;
    }

    .grid-item.selected {
        border-color: #007bff;
        /* Bootstrap primary color */
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
    }

    .folder-item img {
        width: 50px;
        /* Smaller folder icon */
        height: 50px;
        margin-bottom: 8px;
    }

    .project-image {
        width: 100%;
        /* max-width: 150px; /* Max width to control size */
        height: 120px;
        /* Fixed height for uniform look */
        object-fit: cover;
        margin-bottom: 8px;
        border-radius: 3px;
    }

    .item-name {
        font-size: 0.9em;
        width: 100%;
        text-align: center;
        color: #333;
        line-height: 1.3;
    }

    .project-name {
        font-weight: 500;
        /* Slightly bolder */
    }

    h4 {
        margin-top: 10px;
        margin-bottom: 5px;
        font-size: 1.1em;
        color: #555;
    }

    .project-description {
        overflow-y: auto;
        /* Allow description to scroll if needed */
        margin-bottom: 15px;
        /* Space before the button */
        flex-shrink: 1;
        /* Allow description to shrink if space is limited */
    }
</style>